import React from "react";
import { Link } from "react-router-dom";

const MedioMayoristaKitFiberResinCard = () => {
  return (
    <article className="relative mx-auto w-full max-w-[440px] overflow-hidden rounded-xl border border-[#ff2b2b] bg-[#f3f3f3] text-[#111] shadow-[0_8px_20px_rgba(0,0,0,0.16)]">
      <Link to="/productos/medio-mayorista/kit-fibra-resina" className="group block">
        <div className="absolute right-2 top-2 z-10 bg-[#e71318] px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-white md:right-3 md:top-3 md:text-sm">
          Personalizado
        </div>

        <div className="flex aspect-[9/8] w-full items-center justify-center bg-black p-2 md:p-3">
          <img
            src="/ecommerce/FibraResinaForrar.png"
            alt="Kit metro fibra + kilo resina"
            className="h-full w-full object-contain transition duration-200 group-hover:scale-[1.02]"
            loading="lazy"
          />
        </div>

        <div className="space-y-2 p-3 md:space-y-3 md:p-4">
          <h3 className="text-left text-xl font-extrabold uppercase leading-none text-[#101010] md:text-3xl">
            COMBO FIBRA + RESINA
          </h3>

          <p className="text-left text-base leading-tight text-[#1f1f1f] md:text-xl">
            Elige tu fibra y resina a un precio especial.
          </p>

          <div className="text-left text-xl font-extrabold leading-none text-[#e71318] md:text-2xl">
            Ahorra hasta $149
          </div>

          <div className="pt-1">
            <span className="inline-flex min-w-[130px] items-center justify-center rounded-md bg-[#69b636] px-3 py-1.5 text-base font-bold leading-none text-black transition group-hover:brightness-95 md:min-w-[170px] md:px-4 md:py-2 md:text-xl">
              Personalizar <span className="ml-3">→</span>
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
};

export default MedioMayoristaKitFiberResinCard;
